<ng-container *ngIf="loading">
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>


<mat-card appearance="outlined" [hidden]="loading">
	<mat-card-header>
		<!--mat-card-title>{{title}}</mat-card-title-->
    </mat-card-header>
    <mat-card-content>
    	<form class="form-container" (ngSubmit)="onSubmit(companyForm)" #companyForm="ngForm">
    		<mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Generales</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                    <mat-label>RFC</mat-label>
                   	<input matInput type="text" name="company.rfc" [(ngModel)]="company.rfc">
                    <mat-error>{{ violations['company.rfc']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Raz&oacute;n Social</mat-label>
                    <input matInput type="text" name="company.name" [(ngModel)]="company.name">
                    <mat-error>{{ violations['company.name']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Tel&eacute;fono</mat-label>
                  <input matInput type="text" name="company.telephone" [(ngModel)]="company.telephone">
                  <mat-error>{{ violations['company.telephone']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Celular</mat-label>
                  <input matInput type="text" name="company.cellPhone" [(ngModel)]="company.cellPhone">
                  <mat-error>{{ violations['company.cellPhone']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Email</mat-label>
                  <input type="email" matInput placeholder="Ex. pat@example.com" name="company.email" [(ngModel)]="company.email">
                  <mat-error>{{ violations['company.email']}}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer class="example-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>
        <mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Direccion</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">
              <div class="control">
                <mat-form-field class="controlWidth">
                    <mat-label>Estado</mat-label>
                    <input matInput type="text" name="company.addresses.state" [(ngModel)]="company.addresses!.state">
                    <mat-error>{{ violations['company.addresses.state']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Municipio</mat-label>
                    <input matInput type="text" name="company.addresses.municipality" [(ngModel)]="company.addresses!.municipality">
                    <mat-error>{{ violations['company.addresses.municipality']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Colonia</mat-label>
                    <input matInput type="text" name="company.addresses.colony" [(ngModel)]="company.addresses!.colony">
                    <mat-error>{{ violations['company.addresses.colony']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>Calle</mat-label>
                    <input matInput type="text" name="company.addresses.street" [(ngModel)]="company.addresses!.street">
                    <mat-error>{{ violations['company.addresses.street']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>C&oacute;digo Postal</mat-label>
                  <input matInput type="text" name="company.addresses.postal_code" [(ngModel)]="company.addresses!.postal_code">
                  <mat-error>{{ violations['company.addresses.postal_code']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>N&uacute;mero Exterior</mat-label>
                  <input matInput type="text" name="company.addresses.exterior_number" [(ngModel)]="company.addresses!.exterior_number">
                  <mat-error>{{ violations['company.addresses.exterior_number']}}</mat-error>
                </mat-form-field>
              </div>
              <div class="control">
                <mat-form-field class="controlWidth">
                  <mat-label>N&uacute;mero Interior</mat-label>
                  <input matInput type="text" name="company.addresses.interior_number" [(ngModel)]="company.addresses!.interior_number">
                  <mat-error>{{ violations['company.addresses.interior_number']}}</mat-error>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
          <mat-card-footer class="example-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>

        <mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Usuarios actuales</mat-card-title>
            <!--button mat-raised-button color="primary" type="button" (click)="openAddUser()">
              <mat-icon>add</mat-icon>
              Agregar
            </button-->
            <button mat-flat-button class="button" (click)="openAddUser()">
              <mat-icon>add</mat-icon>
              Agregar
            </button>
          </mat-card-header>
          <mat-card-content>
            <div id="container" class="formControl">

              <table mat-table [dataSource]="usersCompany" class="mat-elevation-z8 table-benefits" multiTemplateDataRows>
      
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>Correo</th>
                  <td mat-cell *matCellDef="let row">
                      {{ row.email }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="fullName">
                  <th mat-header-cell *matHeaderCellDef>Nombre</th>
                  <td mat-cell *matCellDef="let row">
                      {{ row.person? row.person.fullName : '' }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="rol">
                  <th mat-header-cell *matHeaderCellDef>Roles</th>
                  <td mat-cell *matCellDef="let row">
                      {{  getRoles(row)  }}
                  </td>
                </ng-container>
               
  
                <tr mat-header-row *matHeaderRowDef="columndefs"></tr>
                <tr mat-row *matRowDef="let row; columns: columndefs;"></tr>
      
              </table>
              
            </div>
          </mat-card-content>
          <mat-card-footer class="example-card-footer">
          </mat-card-footer>
        </mat-card>
        <br>
        <button mat-flat-button class="button" click="onSubmit()">Guardar</button>
    	</form>
    </mat-card-content>
  <mat-card-footer class="example-card-footer">
  </mat-card-footer>
  <br>
</mat-card>